<template>
  <div>
    <ControlPanel :title="'Раздел: Отчёты'" :icon="'mdi mdi-folder'" :links="links">
    </ControlPanel>
    <div class="container-fluid">
      <Category>
        <template v-slot:pos1>
          <p>Этот раздел предназначен для формирования отчетности на основе сохраненных данных по зарплате сотрудников. </p>
        </template>
        <template v-slot:pos2>
          <table class="table table-sm table-bordered">
            <tr><td class="text-center">
              Формат JSON (ИСНА)
            </td></tr>
            <tr>
              <td><b-link to="/fno/200.00/">Регламентированный отчёт: форма 200.00</b-link></td>
            </tr>
            <tr><td class="text-center">
              Формат XML (КНП и СОНО)
            </td></tr>
            <tr>
              <td><b-link to="/reports/200.00/">Регламентированный отчёт: форма 200.00</b-link></td>
            </tr>
            <tr>
              <td><b-link to="/reports/910.00/">Регламентированный отчёт: форма 910.00</b-link></td>
            </tr>
            <tr>
              <td><b-link to="/reports/920.00/">Регламентированный отчёт: форма 920.00</b-link></td>
            </tr>
          </table>
        </template>
      </Category>
    </div>
  </div>
</template>

<script>
import ControlPanel from "@/components/base/ControlPanel";
import Category from "@/components/base/Category";
import {mapGetters} from "vuex";

export default {
  name: 'ReportsDefault',
  components: {
    ControlPanel,
    Category
  },
  data: function () {
    return {

    }
  },
  computed:  {
    ...mapGetters({
      links: 'links'
    })
  },
}
</script>

<style scoped>

</style>
